export const SET_UNKNOWN = "SET_UNKNOWN";

export const setUnknown = (unknown) => ({type: SET_UNKNOWN, unknown});
